import CellHero from "../components/CellHero";
import CellFocus from "../components/CellFocus";
import CellPathwayNav from "../components/CellPathwayNav";
import CellLeadership from "../components/CellLeadership";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function ManagementExcellenceCellPage() {
  return (
    <main className="min-h-screen">
      <CellHero
        name="Management Excellence Cell"
        tagline="Organizational Transformation and Leadership Capacity for Innovation"
        description="The Management Excellence Cell ensures that innovation is not just a technical exercise, but an organizational capability. It builds the governance, decision routines, and leadership mindsets required to sustain innovation beyond any single project."
        icon="ri-team-line"
      />

      <CellFocus
        focus={[
          "Organizational transformation & change discipline",
          "Performance management frameworks",
          "Decision routines & governance",
          "Leadership capacity for innovation",
        ]}
        description="Management creates the conditions under which innovation thrives or dies. This cell builds the frameworks, routines, and leadership skills that turn good ideas into institutionalized practice — from the C-suite to the shop floor supervisor."
      />

      <CellLeadership
        chiefCatalyst={{
          name: "Engr. ATM Mahbubul Alam Milton",
          designation: "Executive Director, Masco Group",
        }}
        moderators={[
          {
            name: "Eousup Abu Abdullah",
            designation: "Former COO, Textile Today; CEO, Mandala AI",
          },
        ]}
      />

      {/* Related Programmes */}
      <section className="bg-tie-navy py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-12">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/10 border border-white/20 mb-4 md:mb-5">
                  <span className="text-xs font-semibold text-white/80 uppercase tracking-wider">
                    / Related Programmes
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                  Building Management-Led Innovation
                </h2>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                { name: "PIIC", desc: "Cross-functional Innovation Circles with management governance", route: "/piic" },
                { name: "Training", desc: "Innovation Black Belt and leadership certification programmes", route: "/training" },
                { name: "Experts", desc: "Management consultants and organizational change specialists", route: "/experts" },
                { name: "PIARC", desc: "Applied research on management and governance best practices", route: "/piarc" },
              ].map((prog, index) => (
                <ScrollReveal key={prog.name} delay={index * 100}>
                  <Link to={prog.route} className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                    <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                    <p className="text-sm text-white/60">{prog.desc}</p>
                    <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                      Learn more <i className="ri-arrow-right-line ml-1.5 text-xs group-hover:translate-x-1 transition-transform" />
                    </span>
                  </Link>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CellPathwayNav />
    </main>
  );
}